// src/modules/login/Login.jsx
import { BaseGatewayDomain } from '@app/utils/apiUrl';
import { FLASH_KEY, LOGIN_SSO_ORIGIN_KEY } from '@app/utils/define';
import {userManager} from '@app/utils/oidc';
import React, {useState, useEffect} from 'react';
import {useLocation} from 'react-router-dom';
import { toast } from 'react-toastify';
import Cookies from 'js-cookie';
// import './Login.scss';

const LoginSSO = () => {
    const {search} = useLocation();
    const [serverError, setServerError] = useState(null);

    // Bắt lỗi do server trả về ?error=invalid_credentials
    useEffect(() => {
        const params = new URLSearchParams(search);
        if (
            params.get('error') === 'invalid_credentials' &&
            serverError === null
        ) {
            setServerError('Sai tên đăng nhập hoặc mật khẩu.');
        }
    }, [search, serverError]);

    useEffect(() => {
        Cookies.set(LOGIN_SSO_ORIGIN_KEY, BaseGatewayDomain, {
            domain: '.cntt108.vn',
            path: '/',
            secure: true,
            sameSite: 'Lax',
            expires: 1
            });

        const raw = localStorage.getItem(FLASH_KEY);

        if (!raw) return;
        try {
            const { level = 'info', text = '' } = JSON.parse(raw);
            if (text) toast[level]?.(text);
        } catch {}
        localStorage.removeItem(FLASH_KEY);
    }, []);

    // Hàm khởi động flow OIDC
    const handleLogin = () => {
        userManager
            .signinRedirect() // Tự động build URL /connect/authorize?client_id=…&code_challenge=…&state=… :contentReference[oaicite:0]{index=0}
            .catch((err) => console.error('OIDC signinRedirect error', err));
    };

    document.getElementById('root').classList = 'hold-transition login-page';

    return (
        <div className="login-box login-box-sso">
            <div className="card card-outline card-primary">
                <div className="card-body" style={{ padding: '30px', paddingBottom: '60px' }}>

                    <div className="text-center mb-4">
                        <img
                            src="/img/logobenhvien108.jpg"
                            alt="Logo BV 108"
                            style={{ width: '100%', maxWidth: '520px', height: 'auto' }}
                        />
                    </div>

                    {serverError && (
                        <div className="alert alert-danger" role="alert">
                            {serverError}
                        </div>
                    )}

                    <button
                        type="button"
                        className="btn btn-primary btn-block"
                        onClick={handleLogin}
                    >
                        Truy cập hệ thống
                    </button>
                </div>
            </div>
        </div>
    );
};

export default LoginSSO;
